import React from 'react';
import { motion } from 'framer-motion';
const pillars = [{
  negation: 'Not a Tool',
  headline: 'A Service',
  headlineColor: 'text-purple-500',
  accentColor: 'bg-purple-500',
  lines: ["Clients don't learn software.", 'They provide materials.', 'We deliver the campaign.']
}, {
  negation: 'Not Months',
  headline: 'Days',
  headlineColor: 'text-green-500',
  accentColor: 'bg-green-500',
  lines: ['AI handles the intelligence.', 'Humans handle the judgement.', 'Delivery is 76% faster.']
}, {
  negation: 'Not One-Off',
  headline: 'Compounding',
  headlineColor: 'text-purple-400',
  accentColor: 'bg-purple-400',
  lines: ['Every campaign feeds data.', 'Expansion opportunities surface.', 'The service improves with scale.']
}];
export function CortexSlide() {
  return <div className="h-full flex flex-col justify-center gap-6" data-id="element-102">
      {/* Sequoia quote */}
      <motion.div initial={{
      opacity: 0,
      y: -12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="rounded-xl overflow-hidden shadow-lg border border-gray-700 max-w-md" data-id="element-103">
        <img src="https://cdn.magicpatterns.com/uploads/fe53pMefsA8SixeudDSB6Q/Screenshot_2026-04-07_at_11.44.16.png" alt="Julien Bek, Partner at Sequoia Capital: The next $1T company will be a software company masquerading as a services firm." className="w-full h-auto object-contain" data-id="element-104" />
      </motion.div>

      {/* Intro text */}
      <motion.div initial={{
      opacity: 0,
      y: -12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} data-id="element-105">
        <p className="text-gray-500 text-base leading-relaxed max-w-3xl" data-id="element-106">
          Snakker doesn't sell a content tool to pharma. It sells finished,
          compliant, interactive campaigns — delivered in days instead of
          months.
        </p>
      </motion.div>

      {/* Three pillars */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-107">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2 + idx * 0.15
      }} className="relative rounded-2xl bg-gray-900 border border-gray-800 p-6 flex flex-col gap-4 overflow-hidden" data-id="element-108">
            {/* Top accent bar */}
            <div className={`absolute top-0 left-0 right-0 h-1 ${pillar.accentColor}`} data-id="element-109" />

            {/* Negation label */}
            <span className="text-sm text-gray-400 font-medium tracking-wide" data-id="element-110">
              {pillar.negation}
            </span>

            {/* Headline */}
            <h3 className={`text-3xl font-bold ${pillar.headlineColor}`} data-id="element-111">
              {pillar.headline}
            </h3>

            {/* Description lines */}
            <div className="space-y-1 mt-auto" data-id="element-112">
              {pillar.lines.map((line, i) => <p key={i} className="text-gray-300 text-sm leading-relaxed" data-id="element-113">
                  {line}
                </p>)}
            </div>
          </motion.div>)}
      </div>
    </div>;
}